 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import S001BOOKTITLEPAGE01 from '@/components/s001-BookTitlePage-01'
 import S002BRIEFTOC01 from '@/components/s002-BriefTOC-01'
 import S003CHAPTER001 from '@/components/s003-Chapter-001'
 import LOVE_2 from '@/components/love_2'
 import S004ABOUTTHEAUTHOR01 from '@/components/s004-AboutTheAuthor-01'
 import S005ADCARD01 from '@/components/s005-AdCard-01'
 import S006TEASER01 from '@/components/s006-Teaser-01'
 import S007CHAPTER002 from '@/components/s007-Chapter-002'
 import S008CHAPTER003 from '@/components/s008-Chapter-003'
 import S009BACKAD01 from '@/components/s009-BackAd-01'
 import S010APPENDIX01 from '@/components/s010-Appendix-01'
 import TOC from '@/components/TOC'
 import S012COPYRIGHT01 from '@/components/s012-Copyright-01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/s001-BookTitlePage-01",
 			"name" : "s001-BookTitlePage-01",
 			"component" : S001BOOKTITLEPAGE01
 		},
 		{
 			"path" : "/s002-BriefTOC-01",
 			"name" : "s002-BriefTOC-01",
 			"component" : S002BRIEFTOC01
 		},
 		{
 			"path" : "/s003-Chapter-001",
 			"name" : "s003-Chapter-001",
 			"component" : S003CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js